/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

const useScreen = () => {
	const [screen, setScreen] = useState(window.innerWidth);

	useEffect(() => {
		const updatePosition = () => {
			setScreen(window.innerWidth);
		};

		window.addEventListener("resize", updatePosition);
		updatePosition();
		return () => window.removeEventListener("resize", updatePosition);
	}, [window.innerWidth]);

	return screen;
};

export default useScreen;
